// Requêtes du super administrateur de la plateforme (D-080) : catalogue des modules, activation
// globale et réglage par collectivité.
import type { ModificationModulePlateforme, ModulePlateforme, ModulesPlateforme } from '@cc/contrats';
import { useQuery } from '@tanstack/react-query';
import { requete } from '../../api/client';

export const CLE_MODULES_PLATEFORME = ['plateforme', 'modules'];

export function useModulesPlateforme() {
  return useQuery({
    queryKey: CLE_MODULES_PLATEFORME,
    queryFn: ({ signal }) => requete<ModulesPlateforme>('/plateforme/modules', { signal }),
  });
}

export function modifierModulePlateforme(code: string, corps: ModificationModulePlateforme) {
  return requete<ModulePlateforme>(`/plateforme/modules/${code}`, { methode: 'PUT', corps });
}

export function modifierModuleCollectivite(code: string, collectiviteId: string, corps: ModificationModulePlateforme) {
  return requete<ModulePlateforme>(`/plateforme/modules/${code}/collectivites/${collectiviteId}`, { methode: 'PUT', corps });
}
